// $body = $("body");

function animateScrollToElement(target){
   $('html, body').animate({
        scrollTop: $(target).offset().top - 300
    }, 800);
   window.location.hash = target;
}

function toggleMainMenu(){
     var target = $('#main-nav')
      if(!target.hasClass('slideInLeft')){
        target.addClass('slideInLeft').removeClass('slideOutLeft');
      }else{
        target.addClass('slideOutLeft').removeClass('slideInLeft');
      }
      $('#navbar-toggler').toggleClass('change');
      $('#darken-content').toggleClass('d-none');
   }

 function selectNavType(){
    var header = $("#masthead");
     if(!header.hasClass('no-transitions')){
      if(window.pageYOffset > 300){
            if(!header.hasClass('solid-background')){
              header.addClass('solid-background');
            }
          }else{
            if(header.hasClass('solid-background')){
              header.removeClass('solid-background');
            }
          }
      }
   }

$(document).ready(function(){
  if(window.innerWidth < 576){
    $("#masthead").addClass('solid-background no-transitions');
  }

  //set nav type by y-offset
  selectNavType();

 //localscroll
  if(window.location.hash){
    animateScrollToElement(window.location.hash);
  }

   $('a[href*="#"]').click(function(e){ 
      e.preventDefault();

      if( $('#main-nav').hasClass('slideInLeft') ){ //if main menu open, close it
        toggleMainMenu(); 
       }

      var hrefAttr = $(this).attr('href');
      var idx = hrefAttr.indexOf("#");
      var target = hrefAttr.substr(idx);


      if(idx === 0){//if link href contains only hash  
         animateScrollToElement(target);
      }else{//if link href contains 

      var hrefAttrPath = hrefAttr.substr(0,idx);
      var thisPage = window.location.host + window.location.pathname;
      if(window.location.port == ''){//port is default 80
        thisPage = window.location.protocol + '//' + thisPage;
      }else{//if link href doesn't contain protocol
       hrefAttrPath = hrefAttrPath.replace('//', '');
      }
      
        if(thisPage == hrefAttrPath){ //target in same page
          var target = hrefAttr.substr(idx);
           animateScrollToElement(target);
        }else{
           window.location.href = hrefAttr;
        }

      }
      
   });

  //carousel
   $('.carousel').slick({
    dots: true,
    autoplay:true,
    adaptiveHeight: false,
     customPaging : function(slider, i) {
        return '<button class="slider-dot"></button>';
    },
     arrows: false
   });

   //seach form
   $('#searchform button[type="submit"]').click(function(e){
      e.preventDefault();
      var searchForm = $(this).closest('#searchform');
      var inputVal = searchForm.find('#s').val();
       if(inputVal !== '' && inputVal !== null){
        //console.log('kamaa');
        searchForm.submit();
       }
   });

   //navigation
   $('#navbar-toggler, #darken-content').click(function(){
   		toggleMainMenu();
   });

   

   /* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
  var prevScrollpos = window.pageYOffset;
    window.onscroll = function() {
     
    selectNavType();
      

    if($('#darken-content').hasClass('d-none')){
      var currentScrollPos = window.pageYOffset;
      if (prevScrollpos > currentScrollPos) {//scroll up
        document.getElementById("masthead").style.top = "0";
      } else if( currentScrollPos > 100) {//scroll down and at least 100 from top
        document.getElementById("masthead").style.top = "-60px";
      }
      prevScrollpos = currentScrollPos;
    }
  }

});//document ready


// WEBPACK FOOTER //
// ./js/general.js